import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';
import {
  DeleteDraftDto,
  RequestAddSettingDto,
  RequestDeleteClaimDto,
  RequestEditReqDto,
  RequestGetClaimItemFormNew,
  ResponseCurrencyList
} from '../dto/claim.dto';
import {ResponseData} from '../../nest-responses';

@Injectable()
export class ClaimApiOnly {

  private service: string = 'attendance';
  private model: string = 'claim';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public getClaimHistory(limit: string | number, page: string | number, requestfor: string): Observable<any> {

    const method: string = 'GET';
    const func: string = 'getClaimHistory';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof requestfor !== 'undefined' && requestfor !== null) urlParams.requestfor = requestfor;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getClaimItem(limit: string | number, page: string | number, requestedby: string, reimrequestId?: string[]): Observable<any> {

    const method: string = 'GET';
    const func: string = 'getClaimItem';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;
    if (typeof requestedby !== 'undefined' && requestedby !== null) urlParams.requestedby = requestedby;
    if (typeof reimrequestId !== 'undefined' && reimrequestId !== null) urlParams.reimrequestId = reimrequestId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getRequest(reqNo: string): Observable<any> {

    const method: string = 'GET';
    const func: string = 'getRequest';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof reqNo !== 'undefined' && reqNo !== null) urlParams.reqNo = reqNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getClaimItemApproval(requestNo: string): Observable<any> {

    const method: string = 'GET';
    const func: string = 'getClaimItemApproval';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public cancelItemByReqId(requestNo: string): Observable<any> {

    const method: string = 'GET';
    const func: string = 'cancelItemByReqId';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public claimItemByReqId(param: any): Observable<any> {

    const method: string = 'GET';
    const func: string = 'claimItemByReqId';
    const params: any = {};
    const urlParams: any = param || {};
    const body: any = {};

    // if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    // if (typeof flag !== 'undefined' && flag !== null) urlParams.flag = flag;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public addClaim(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getRequestDetail(requestNo: string): Observable<any> {

    const method: string = 'GET';
    const func: string = 'getRequestDetail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getClaimSetting(): Observable<any> {

    const method: string = 'GET';
    const func: string = 'getClaimSetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }

  public getCurrencyList(): Observable<ResponseData<ResponseCurrencyList[]>> {

    const method: string = 'GET';
    const func: string = 'getCurrencyList';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseCurrencyList[]>>(method, url, params, urlParams, body);
  }

  public add(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public editClaimSetting(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'editClaimSetting';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approve(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approve';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public reject(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'reject';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public revise(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'revise';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public editClaim(payload: any): Observable<any> {
    const method: string = 'POST';
    const func: string = 'editClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  // tiket TCK2107-0661176
  // public getClaimItemForm(payload: RequestGetClaimItemForm, paging: RequestPaging): Observable<any> {
  //   const method: string = 'POST';
  //   const func: string = 'getClaimItemForm';
  //   const params: any = payload || {};
  //   const urlParams: any = paging || {};
  //   const body: any = {};

  //   const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
  //   return this.nestApiProvider.request(method, url, params, urlParams, body);
  // }

  public getClaimItemForm(param: RequestGetClaimItemFormNew): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getClaimItemForm';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const model: string = 'SFClaimRequests';
    
    if (typeof param.limit !== 'undefined' && param.limit !== null) urlParams.limit = param.limit;
    if (typeof param.page !== 'undefined' && param.page !== null) urlParams.page = param.page;
    if (typeof param.approvalStatus !== 'undefined' && param.approvalStatus !== null) urlParams.approvalStatus = param.approvalStatus;
    if (typeof param.requestNo !== 'undefined' && param.requestNo !== null) urlParams.requestNo = param.requestNo;
    if (typeof param.requestedby !== 'undefined' && param.requestedby !== null) urlParams.requestedby = param.requestedby;
    if (typeof param.reimrequestIds !== 'undefined' && param.reimrequestIds !== null) urlParams.reimrequestIds = param.reimrequestIds;

    const url = this.nestApiProvider.urlBuilder(method, model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public deleteClaim(payload: RequestDeleteClaimDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'deleteClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteClaimSetting(payload: any): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'checkDeleteClaim';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public editReq(payload: RequestEditReqDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'editReq';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteDraft(payload: DeleteDraftDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public addSetting(payload: RequestAddSettingDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'addSetting';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/claim.api.ts